import { TableCell as MuiTableCell, type TableCellProps as MuiTableCellProps } from '@mui/material';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';

const HEADER_CELL_ELEMENT = 'th';

type Props = WithoutStyleOverrides<MuiTableCellProps>;

export function TableCell(props: Props) {
  return <MuiTableCell {...props} component={props.scope === undefined ? undefined : HEADER_CELL_ELEMENT} />;
}

export type { Props as TableCellProps };
